import AscensionSplash from '../components/AscensionSplash';
import Login from '../components/Login';
import { fullscreenRoutes } from '../navigation/routes';
import AppChrome from './AppChrome';
import { ApplicationProvider, useApplication } from './ApplicationState';
import { renderStandaloneRoute, WorkspaceRoute } from './AppRoutes';
import DimensionWorkspace from '../platforms/web/desktop/DimensionWorkspace';
import { dimensions } from '../platforms/web/desktop/dimensions';
import LoadingScreen from './LoadingScreen';

function ApplicationScreen() {
  const state = useApplication();
  if (state.authLoading) return <LoadingScreen />;
  if (!state.isAuthenticated) return <Login />;
  if (state.showAscensionSplash)
    return <AscensionSplash onEnter={() => state.setShowAscensionSplash(false)} />;
  const dimension = dimensions.find(d => d.route === state.navigation.current.route);
  const content = fullscreenRoutes.has(state.navigation.current.route) ? renderStandaloneRoute(state) : <WorkspaceRoute />;
  return (
    <AppChrome>
      {dimension ? <DimensionWorkspace key={`${state.authUser?.id}:${dimension.key}`} dimension={dimension.key}>{content}</DimensionWorkspace> : content}
    </AppChrome>
  );
}
export default function Application() {
  return (
    <ApplicationProvider>
      <ApplicationScreen />
    </ApplicationProvider>
  );
}
